import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import * as actions from '@app/actions/index';
import * as models from '@app/models/index';
import { IInjectedAppModuleProps } from '@app/providers/app-module.provider';
import HeaderComponent from './header.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(
	dispatch: Dispatch<actions.AuthActions>
): Omit<models.IHeaderComponentProps, keyof RouteComponentProps | keyof IInjectedAppModuleProps> {
	return {
		onUserSignOut: () => dispatch(actions.userSignedOutAction()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent);



// WEBPACK FOOTER //
// ./src/components/core/header/header.ts